import { render, staticRenderFns } from "./PackagesIndex.vue?vue&type=template&id=4b646b27&scoped=true"
import script from "./PackagesIndex.vue?vue&type=script&lang=js"
export * from "./PackagesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b646b27",
  null
  
)

export default component.exports